export enum EvaluationFormStatus {
  Pending,
  Coached,
  Approved,
  Disputed,
  Saved
}